export const PROVIDER_FULL_DAY_HOURS = 8;
export const PROVIDER_FULL_DAY_MINUTES = PROVIDER_FULL_DAY_HOURS * 60;

export function calculateProviderLoadPercentage(
  assignedMinutes: number,
  capacityMinutes = PROVIDER_FULL_DAY_MINUTES
) {
  if (!Number.isFinite(assignedMinutes) || assignedMinutes <= 0) return 0;
  if (!Number.isFinite(capacityMinutes) || capacityMinutes <= 0) return 0;

  return (assignedMinutes / capacityMinutes) * 100;
}
